<template>
  <div>
    <!-- 导师辅导 -->
    <div class="coach">
      <div class="coach-title">
        <div class="coach-title-me">我的导师辅导</div>
        <div v-if="plan !== 'intern' && task.state === 'end'">辅导剩余 <span>0</span> 天</div>
      </div>
      <div class="coach-title" style="margin-top: -20px; margin-bottom: 8px;" v-if="plan !== 'intern' && task.state !== 'end'">
        <div v-if="plan !== 'intern'">辅导剩余 <span>{{(task.countdown || '').replace(/(\d{0,})(.*)/, '$1')}}</span> {{(task.countdown || '').replace(/(\d{0,})(.*)/, '$2')}}</div>
        <div v-else></div>
        <button class="coach-end-btn" v-if="task.state !== 'end' && !mentor" @click="endOrder">结束订单</button>
      </div>

      <div class="coach-progress">
        <div class="coach-progress-menu action"></div>
        <div :class="['coach-progress-menu', getCoachClassNamem(1, task)]"></div>
        <div :class="['coach-progress-menu', getCoachClassNamem(2, task)]"></div>
        <div :class="['coach-progress-menu', getCoachClassNamem(3, task)]"></div>
      </div>
      <div class="coach-progress-text">
        <div class="active"><p>分配导师</p><p class='task-date'>{{moment(task.create_at).format('MM/DD')}}</p></div>
        <div :class="[getCoachClassNamem(1, task) ? 'active' : '']"><p>修改中&nbsp;&nbsp;&nbsp;</p><p class='task-date'>{{task.state === 'unanswered' ? moment(task.updated_at).format('MM/DD') : ''}}</p></div>
        <div :class="[getCoachClassNamem(2, task) ? 'active' : '']"><p>已修改&nbsp;&nbsp;&nbsp;</p><p class='task-date'>{{(task.state === 'replied') ? moment(task.updated_at).format('MM/DD') : ''}}</p></div>
        <div :class="[getCoachClassNamem(3, task) ? 'active' : '']"><p>辅导结束</p><p class='task-date'>{{task.state === 'end' ? moment(task.finished_at).format('MM/DD') : ''}}</p></div>
      </div>
      <div class="coach-progress-message">
        <span v-html="getCoachText(task)"></span>
      </div>
      <div class="coach-progress-btn active" @click="submitFeedback(true)" v-if="task.state !== 'end' && plan !== 'intern' && !mentor" >
        提交给导师 <!-- :class="['coach-progress-btn', task.state === 'replied' task.state === 'replied' ? 'active' : '']" -->
        <!--div class="coach-toast"></div-->
      </div>
      <div class="coach-progress-btn active" @click="submitFeedback(true)" v-if="task.state !== 'end' && mentor" >
        提交给用户 <!-- :class="['coach-progress-btn', task.state === 'unanswered' ? 'active' : '']" task.state === 'unanswered' -->
        <!--div class="coach-toast"></div-->
      </div>

      <div class="coach-name cursor_p" @click="showMore.order = !showMore.order">
        <span>订单信息</span>
        <i :class="['iconfont', 'iconchevron-down', showMore.order ? 'active' : '']"></i>
      </div>
      <div class="orderContent f_14" v-show="showMore.order">
        <p><span class="color_60">产品名称：</span><span class="color_9c">{{mentorOrders.display_plan}}</span></p>
        <p><span class="color_60">简历语言：</span><span class="color_9c">{{mentorOrders.cv_lang_desc}}</span></p>
        <p><span class="color_60">目标行业领域：</span><span class="color_9c">{{mentorOrders.industry_desc}}</span></p>
        <p><span class="color_60">是否转行：</span><span class="color_9c">{{mentorOrders.change_profession?'是':'否'}}</span></p>
        <p><span class="color_60">加急选项：</span><span class="color_9c">{{mentorOrders.urgency_desc}}</span></p>
      </div>
      <div class="coach-name cursor_p" @click="showMore.question = !showMore.question">
        <span>用户提问</span>
        <i :class="['iconfont', 'iconchevron-down', showMore.question ? 'active' : '']"></i>
      </div>
      <div class="orderContent f_14 color_9c" v-show="showMore.question">
        <p v-if='mentorOrders.question'>{{mentorOrders.question}}</p>
        <p v-else>未填写</p>
      </div>
      <div class="coach-name">
        <span>申请职位</span>
      </div>
      <div class="orderContent">
        <a class="coach-url text-overflow" :href="job_url" v-if="job_url" target="_blank">{{job_url}}</a>
        <span class="coach-url" style="color: #9C9C9C; font-size: 12px;" v-else>未填写</span>
      </div>

      <div class="coach-name">
        <span>问题回复</span>
        <i :class="['iconfont', 'iconchevron-down', coachShow ? 'active' : '']" @click="coachShow = !coachShow" v-if="mentorData.mentor_round > 0"></i>
      </div>
      <!-- 问题回复 -->
      <div class="coach-reply-content" ref="coachContent" v-show="coachShow" v-if="mentorData.mentor_round > 0">
        <div v-for="(item, index) in comments" :key="index">
          <template v-for="(sitem, sindex) in item">
            <div class="coach-reply-menu" :key="sindex">
              <div class="coach-reply-title">
                <div class="coach-reply-user">
                  <img :src="sitem.creator_avatar || 'https://files.wondercv.com/default_forum_icon.png'" alt="">
                  <span>{{sitem.creator_name}}</span>
                </div>
                <div class="coach-reply-date">{{sitem.create_time}}</div>
              </div>
              <div class="coach-reply-text" v-html="sitem.desc"></div>
            </div>
          </template>
          <!-- <div class="splitLine f_14 text_center" v-if="!(task.state === 'replied' || task.state === 'unanswered') || index!==comments.length-1"><span class="pr">第 {{index+1}} 轮已结束</span></div> -->
          <div class="splitLine f_14 text_center" v-if="index!==comments.length-1"><span class="pr">第 {{index+1}} 轮已结束</span></div>
          <div class="splitLine f_14 text_center" v-else-if="getCoachClassNamem(3, task)"><span class="pr">辅导已结束</span></div>
          
          <!-- 辅导已结束 -->
        </div>
      </div>
      <div class="coach-reply-content" v-show="coachShow" v-else style='text-align: center; color:#bcbcbc; margin: 52px 0;'>
        <img src='https://files.wondercv.com/company/privacy-company-zero.png' style='width: 74px; height: 74px; margin: auto;'/>
        <div style='margin-top: 8px;'>暂无消息</div>
      </div>
      <!-- 导师输入框- 学生提问 -->
       <!-- && plan !== 'intern' 导师辅导是实习版用户不能提问 -->
      <div class="coach-reply" @click="$refs.coach.focus()" v-if="task.state !== 'end' && !mentor">
        <textarea placeholder="请输入您的问题" v-model="coach" ref="coach"></textarea>
        <button @click="coachSubmit()">提问</button>
      </div>
      <!-- 学生输入框-没有结束，导师能一直回答 -->
      <div class="coach-reply" @click="$refs.coach.focus()" v-if="task.state !== 'end' && mentor">
        <textarea placeholder="请输入您的回答" v-model="coach" ref="coach"></textarea>
        <button @click="coachSubmit()">回答</button>
      </div>
      
    </div>

    <!-- 反馈 -->
    <div class="feedback" v-if="!mentor">
      <div class="feedback-title">您对这次导师辅导满意吗？</div>
      <div class="feedback-content" v-if="!rate">
        <div class="feedback-menu" @click="submitRate('满意')"><img src="https://files.wondercv.com/pcvue/rate1.png">满意</div>
        <div class="feedback-menu" @click="submitRate('一般')"><img src="https://files.wondercv.com/pcvue/rate2.png">一般</div>
        <div class="feedback-menu" @click="submitRate('不满意')"><img src="https://files.wondercv.com/pcvue/rate3.png">不满意</div>
      </div>
      <div class="feedback-content" v-else>
        感谢您的反馈！详细的建议可在问卷中填写或直接找客服反馈。
      </div>
      <div class="feedback-btn">
        <a class="active" href="https://wj.qq.com/s2/3590730/a259/" target="_blank">填问卷</a>
        <a @click="showUdesk">找客服</a>
      </div>
    </div>

  </div>
</template>
<script>
import { dealSignatrue, routerTo } from '@/assets/js/util';
import api from '@/api';
import { mapState } from 'vuex';
import moment from 'moment';
export default {
  name: 'Coach',
  data() {
    return {
      // 导师辅导
      comments: [],
      task: {},
      coach: '',
      question: '',
      job_url: '',
      coachShow: true,
      rate: '',
      urgency: '',
      plan: '',

      isExample: true, // 显示大牛案例
      isVerb: true, // 常用动词显示
      isQuestion: false, // 问题是否隐藏f ot t
      isMore: true, // 显示产看更多
      showText: '', // 显示的文本
      moment,

      mentorOrders:{}, //订单信息
      showMore:{ //订单信息展开/收起
        order:true,
        question: true,
      },
      mentorData:{},
    };
  },
  computed: {
    // ...mapState('cvsEditor', [ 'mentor']),
    ...mapState('editor', ['cvToken']),
    mentor () {
      return window.location.href.includes('mentor')
    }
  },
  mounted() {
    this.getComments();
    //根据简历token获取订单信息
    this.getCvTokenMentorOrders();
  },
  methods: {
    setShowText() {
      return false;
      let length = 0;
      let str = '';
      let question = JSON.parse(JSON.stringify(this.question))
      // let question = 'sfsafadsff ff ffff fffdsff ff ffff fffdsff ff ffff fffdsff ff ffff fffdsff ff ffff fff ffff fffff ffff ffffasfa sdfasdf asdfa dsgasasdfa dsgasasdfa dsgasasdfa dsgasasdfa dsgas dfasdfadsfadsfa sdfffffffffff fffafads fasdgasdfas'
      // let question = '我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提问！！！我要提'
      if (!this.isQuestion) {
        this.showText = question;
        return false;
      }
      if (question.length <= 4) {
        this.showText = question;
        return false;
      }
      for (let i = 0; i < question.length; i++) {
        if (length <= 250) {
          str += question[i];
          let isSBC = question[i].match(/[\u4e00-\u9fa5]/g)
            || question[i].match(/[\uff00-\uffff]/g);
          if (isSBC) {
            length += 3;
          }
          else {
            length++;
          }
          this.isQuestion = false;
          this.isMore = false;
        }
      }
      if (length >= 220) {
        str += '...'
        this.isQuestion = true;
        this.isMore = true;
      }
      else {
        this.isQuestion = false;
        this.isMore = false;
      }
      this.showText = str;
    },
    // 获取导师辅导结束状态，时间为0时
    getEndTimeStatus() {
      let countdown = this.task.countdown;
      let isTrue = countdown === '0天'
        || (countdown || '').replace(/(\d{1,}).*/gim, '$1') == 0;
      this.task.state = isTrue ? 'end' : this.task.state;
      return isTrue;
    },
    showQuestion() {
      let dom = this.$refs.question;
      if (dom) {
        let height = dom.offsetHeight;
        if (height - 16 > 16 * 4) {
          this.isQuestion = true;
          this.isMore = true;
        } else {
          this.isQuestion = false;
          this.isMore = false;
        }
      }
      return true;
    },
    // lookCvIssue() {
    //   this.$message.error('今日免费检查次数已用完');
    //   this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip'})
    // },
    // 导师辅导-结束订单
    async endOrder() {
      const alertData = {
        show: true,
        type: 'message',
        messageTitle: '温馨提示',
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 'cvs-edit-cancelButtonClass',
        cancelButtonClass: 'cvs-edit-confirmButtonClass',
        messageContent: `
          <p>即将提前结束导师辅导服务，是否现在结束订单？</p>
        `,
        confirm: async close => {
          close();
          let params = await dealSignatrue({ complete: true, cv_token: this.cvToken});
          let res = await api.cvsEditor.updateTaskState(params);
          if (res.code === 1000) {
            this.$message.success('结束订单成功');
          } else {
            this.$message.error(res.message);
            return false;
          }
          this.getComments();
        },
        cancel: async close => {
          close();
        }
      };
      this.$store.dispatch('app/setAlertData', alertData);
    },
    // 提交意见
    async submitRate(rate) {
      let params = {
        cv_token: this.cvToken,
        rate
      };
      params = await dealSignatrue(params);
      let res = await api.cvsEditor.mentorUpdateRate(params);
      if (res.code === 1000) {
        this.$message.success('提交成功');
        this.rate = rate
      } else {
        this.$message.error('提交失败');
        return false;
      }
      this.getComments();
    },
    showUdesk() {
      let udesk_container = document.querySelector('#udesk_btn a');
      if(udesk_container!=null){
        udesk_container.click();
      }
    },
    // 提交给导师
    async submitFeedback(isTrue) {
      if (!isTrue) {
        return false;
      }
      const alertData = {
        show: true,
        type: 'message',
        messageTitle: '温馨提示',
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 'cvs-edit-cancelButtonClass',
        cancelButtonClass: 'cvs-edit-confirmButtonClass',
        messageContent: `
          <p>即将把简历和问题提交给${this.mentor?'用户':'导师'}，是否确认已修改完毕？</p>
        `,
        confirm: async close => {
          close();

          try {
            let res = await api.cvsEditor.updateTaskState({ cv_token: this.cvToken});
            await api.mentorOrders.mentorCvsSync(this.cvToken);
            console.log(res)
            if (res.code === 1000) {
              this.$message.success('提交成功');
            } else {
              this.$message.error(res.message);
            }
            this.getComments();
          } catch (error) {
            
          }
        },
        cancel: async close => {
          close();
        }
      };
      this.$store.dispatch('app/setAlertData', alertData);



    },
    // 获取导师辅导文案
    getCoachText(task) {
      if (task.state === 'end' || this.getEndTimeStatus() || task.state === "user_overdue") {
        return this.mentor ? '辅导订单已结束，感谢您的认真辅导！' : `辅导订单已结束，您可以对此次辅导的导师做出评价`;
      }
      else if (task.state === 'replied') {
        return this.mentor ? '已提交反馈给用户，如有其他需补充的内容，可继续回复用户' : '导师已给出反馈，如有其它问题，请先提问，然后提交给导师继续修改';
        
      }
      else if (task.state === 'unanswered') {
        return this.mentor ? '请根据用户求职目标，结合具体问题给出建议，可在简历中用【】标注和修改' : `导师正在对您的简历作出修改建议，预计 <b style="color: #FF4F4C;">${this.urgency === '24hours' ? '1' : (this.urgency === '48hours' ? '2' : '3')}个工作日</b> 收到回复，请耐心等待`;
      }
      else {
        return `数据正在加载中...`;
      }
    },
    // 获取导师辅导进度classname
    getCoachClassNamem(type, task) {
      // unanswered replied end
      if (type === 1) {
        if (task.state === 'unanswered') return 'active';
        else return 'action';
      }
      else if (type === 2) {
        if (task.state === 'end'|| task.state === "user_overdue" || this.getEndTimeStatus()) return 'action';
        else if (task.state === 'replied') return 'active';
        else return '';
      }
      else if (type === 3) {
        if (task.state === 'end' || task.state === 'user_overdue' || this.getEndTimeStatus()) return 'active';
        else return '';
      }
    },
    // 导师辅导提交问题
    async coachSubmit() {
      if (!this.coach) {
        this.$message.error('请填写问题');
        return false;
      }
      let params = {
        description: this.coach,
        mentor_round:this.comments.length,
      };
      params = await dealSignatrue(params);
      let res = await api.cvsEditor.createTaskComment(this.cvToken, params);
      console.log('res==== ')
      console.log(res)
      if (res.code === 1000) {
        this.$message.success('提交成功');
        this.coach = '';
        this.getComments();
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取导师辅导剩余天数
    getDayDate(d) {
      let time = new Date(d).getTime() - Date.now();
      if (time <= 0) {
        return 0;
      }

      return ~~(time / 1000 / 60 / 60 / 24);
    },
    async getComments() {
      // if (!this.cv.base.mentor_id) {
      //   return false;
      // }
      let res = await api.cvsEditor.mentorComments(this.cvToken);
      
      if (res.code === 1000) {
        let comments = [];
        this.mentorData = res.data;
        for(let i=0; i<res.data.mentor_round; i++){
          let item = res.data.comments[i+1] || [];
          item.forEach(item => {
            item.desc = item.desc ? item.desc.replace(/\n/g, '<br/>') : '';
          });
          comments.push(item)
        }

        this.comments = comments;
        this.task = res.data.task;
        this.question = res.data.question;
        this.job_url = res.data.job_url;
        this.rate = res.data.rate;
        this.urgency = res.data.urgency;
        this.plan = res.data.plan;
        setTimeout(() => {
          this.$nextTick(() => {
            this.showQuestion();
            if(this.$refs.coachContent){
              this.$refs.coachContent.scrollTo(0,1000);
            }
          });
        }, 500);
      }
    },
    //根据简历token获取导师订单信息
    getCvTokenMentorOrders(){
      api.mentorOrders.getCvTokenMentorOrders(this.cvToken).then(res=>{
        if(res.code === 1000){
          this.mentorOrders = res.data;
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  @import 'coach'
</style>
